import { type AreaType, type BountyActiveDayType } from 'src/api/fm/zones/zones.model'

export const AREA_TYPES_EXCLUDING_BOUNTY: AreaType[] = [
    'operations',
    'no-parking',
    'no-riding',
    'no-start',
    'incentive',
    'slow-zone',
    'parking-spot',
    'fleet-capacity',
    'soft-mpz',
    'free-floating',
]

export const AREA_TYPES_INCLUDING_BOUNTY: AreaType[] = ['bounty', ...AREA_TYPES_EXCLUDING_BOUNTY]

export const WEEKDAYS: BountyActiveDayType[] = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
]

export const AREA_TYPE_LABELS: Record<AreaType, string> = {
    bounty: 'Bounty Zone',
    operations: 'Operational area',
    'no-parking': 'No-parking zone',
    'no-riding': 'No-riding zone',
    'no-start': 'No-start zone',
    incentive: 'Incentivized parking zone',
    'slow-zone': 'Slow-speed zone',
    'parking-spot': 'Parking spot',
    'fleet-capacity': 'Fleet capacity zone',
    'soft-mpz': 'Soft MPZ area',
    'free-floating': 'Free floating area',
}
